module.exports = __webpack_public_path__ + "static/img/kepu.eaaafd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kepu.png
// module id = tzbQ
// module chunks = 21